import TimezoneSelect from "react-timezone-select";
import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "lib/UserContext";
//import { useForm } from "react-hook-form";
import pb from "lib/pocketbase";
import toast from "react-hot-toast";
import { Tabs, Tab } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export default function Settings() {
  // const { register, handleSubmit } = useForm();
  const { user, setUser } = useContext(UserContext);
  const [currentTimezone, setCurrentTimezone] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [enteredGoal, setEnteredGoal] = useState(user.daily_goal);

  const [isLoading, setLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const navigate = useNavigate();

  async function handleGoal(data) {
    try {
      setLoading(true);
      const record = await pb
        .collection("users")
        .update(user.id, { daily_goal: data.daily_goal });
      setUser(record);
      reset();
      //toast.success(`Daily Goal updated to ${record.daily_goal}`);
      toast.success((t) => (
        <span>
          Daily Goal: <b>{record.daily_goal}</b>
        </span>
      ));
    } catch (e) {
      alert(e);
      reset();
    }
    setLoading(false);
  }

  async function handleEndingHour(data) {
    try {
      setLoading(true);
      const record = await pb
        .collection("users")
        .update(user.id, { ending_hour: data.ending_hour });
      setUser(record);
      reset();
      //toast.success(`Daily Goal updated to ${record.daily_goal}`);
      toast.success((t) => (
        <span>
          Ending Hour: <b>{record.ending_hour}</b>
        </span>
      ));
    } catch (e) {
      alert(e);
      reset();
    }
    setLoading(false);
  }

  useEffect(() => {
    fetch(`https://zendash.fly.dev/api/collections/users/records/${user.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((record) => {
        setCurrentTimezone(record.timezone_name);
        setEnteredGoal(record.daily_goal);
      });
  }, []);

  return (
    <div className="d-flex flex-column  ">
      <h3 className="text-center mb-4">{user.name}'s Settings</h3>
      <div className="card shadow mb-4">
        <h6 className="card-header text-center">Daily Goal</h6>
        <div className="card-body">
          <form className="" id="goal" onSubmit={handleSubmit(handleGoal)}>
            <input
              className="form-control mb-3"
              type="number"
              placeholder={`currently: ${user.daily_goal}`}
              {...register("daily_goal")}
            />
            <button
              className="btn btn-outline-primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Set Daily Goal"}
            </button>
          </form>
        </div>
      </div>
      <div className="card shadow mb-4">
        <h6 className="card-header text-center">Timezone</h6>
        <div className="card-body" id="timezone">
          <TimezoneSelect
            value={selectedTimezone}
            onChange={setSelectedTimezone}
            className="mb-3"
          />{" "}
          <button
            type="submit"
            className="btn btn-outline-primary"
            onClick={async () => {
              if (selectedTimezone) {
                const record = await pb.collection("users").update(
                  user.id,
                  JSON.stringify({
                    timezone_name: selectedTimezone.label,
                    utc_offset: selectedTimezone.offset,
                  })
                );
                setUser(await record);
                toast.success((t) => (
                  <div>
                    <span>
                      Timezone: <b>{selectedTimezone.label}</b>{" "}
                    </span>{" "}
                  </div>
                ));
              } else {
                toast.error("Select a timezone");
              }
            }}
          >
            Set Timezone{" "}
          </button>
          {/* {selectedTimezone && (
            <div
              style={{
                backgroundColor: "#ccc",
                padding: "5px",
                margin: "5px auto",
                borderRadius: "5px",
                maxWidth: "600px",
              }}
            >
              <pre
                style={{
                  margin: "0 5px",
                  fontWeight: 500,
                  fontFamily: "monospace",
                }}
              >
                {JSON.stringify(selectedTimezone, null, 2)}
              </pre>
            </div>
          )} */}
        </div>
        <div className="card-footer small">
          {" "}
          {user.timezone_name
            ? `Currently: ${user.timezone_name}`
            : `No timezone set currently`}
        </div>
      </div>
      <div className="card shadow mb-4">
        <h6 className="card-header text-center">Ending Hour</h6>
        <div className="card-body">
          <form
            className=""
            id="goal"
            onSubmit={handleSubmit(handleEndingHour)}
          >
            <input
              className="form-control mb-3"
              type="number"
              placeholder={`currently: ${user.ending_hour} (local time)`}
              {...register("ending_hour")}
            />
            <button
              className="btn btn-outline-primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Set Ending Hour"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
